module.exports = __webpack_public_path__ + "static/media/img_bacode.9fe9088a.jpg";